import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SensorDataModel, SensorHolderType } from '../models/sensor.model';

@Injectable({ providedIn: 'root' })
export class SensorsHttpService {

  private baseUrl = `/sensors`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  /**
   * Get all sensors for a specific holder (LogisticsVehicle or Agent)
   * API: GET v2/sensors/{holderType}/{holderId}
   * Returns array of temperature sensors only
   */
  getSensors(holderType: SensorHolderType, holderId: string): Observable<SensorDataModel[]> {
    return this.http.get<SensorDataModel[]>(`${this.baseUrl}/${holderType}/${holderId}`)
      .pipe(
        map(response => {
          if (!response) {
            return [];
          }
          // Filter to only show Temperature sensors
          return response.filter(sensor => sensor.sensorType === 'Temperature');
        }),
        catchError(err => {
          console.error('Sensors API error:', err);
          return of([]);
        })
      );
  }
}
